import styled from 'styled-components';

import { CUSTOMIZE_RAIL_Z_INDEX } from './CustomizableDashboard.style';
import { DASHBOARD_GRID_MARGIN } from './widgetSizePresets';

export const ToolbarRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  padding: 0 ${DASHBOARD_GRID_MARGIN[0]}px;
`;

/** Customize mode's toolbar and banner in one, pinned to the top of the grid. */
export const CustomizeRail = styled.div`
  position: sticky;
  top: 0;
  z-index: ${CUSTOMIZE_RAIL_Z_INDEX};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  padding: 8px 12px 8px 14px;
  border-radius: 10px 10px 0 0;
  background: ${({ theme }) => theme.teal};
  color: ${({ theme }) => theme.solidActionText};
  font-size: 0.82rem;
  line-height: 1.4;
`;

export const RailLabel = styled.div`
  flex: 1 1 320px;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  .anticon {
    flex: 0 0 auto;
    font-size: 1rem;
  }

  strong {
    font-weight: 700;
    white-space: nowrap;
  }
`;

export const RailHint = styled.span`
  font-weight: 500;
  opacity: 0.85;
`;

export const SaveIndicator = styled.span.attrs({ role: 'status', 'aria-live': 'polite' })`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.solidActionText};
`;
